import React, { type JSX } from 'react';
import UrvalToolbarQueryDoc from './UrvalToolbarQuery.gql';

import {
  UrvalToolbarQuery as IUrvalToolbarQueryData,
  UrvalToolbarQueryVariables as IUrvalToolbarQueryVariables,
} from './_QueryTypes/UrvalToolbarQuery';
import { subsystemCodeFromCollectionName } from '../../../../../Model/avenyModelUtils';
import useHandledQuery from '../../../../QueryComponents/HandledQuery/HandledQueryHook';

interface IProps {
  dbName: string;
  children: (data: IUrvalToolbarQueryData) => JSX.Element;
  collectionName: string;
}

const UrvalToolbarQuery: React.FunctionComponent<IProps> = props => {
  const queryResult = useHandledQuery<
    IUrvalToolbarQueryData,
    IUrvalToolbarQueryVariables
  >(
    UrvalToolbarQueryDoc,
    {
      variables: {
        dbName: props.dbName,
        subsystemCode: subsystemCodeFromCollectionName(props.collectionName),
      },
    },
    {
      loadingComponent: null,
      errorComponent: () => <span>Error</span>,
    }
  );

  if (!queryResult.data) {
    return queryResult.renderComponent;
  }

  return <>{props.children(queryResult.data)}</>;
};

export default UrvalToolbarQuery;
